import React from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentFailed.css";
import failedImage from "../../../assets/images/failed.png";

const OfflinePaymentFailed = () => {
  const navigate = useNavigate(); // Initialize navigate function

  return (
    <div className="payment-failed-container">
      <div className="payment-failed-screen">
        <div className="content">
          <img src={failedImage} alt="Payment Failed" className="failed-img" />
          <h2>Payment Failed</h2>
          <p>Oops! Something went wrong. Please try again.</p>

          <div className="contact-info">
            <p>
              Email:{" "}
              <a href="mailto:Info.Occultking@gmail.com">
                Info.Occultking@gmail.com
              </a>
            </p>
            <p>
              Phone: <a href="tel:+919157591373">+91 9157591373</a>
            </p>
          </div>

          <p className="query-text">
            If you have any queries, please contact us.
          </p>
          <button className="go-back-btn" onClick={() => navigate("/")}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfflinePaymentFailed;
